import React, { useRef } from 'react';
import Button from 'react-bootstrap/Button';
import { useTranslation } from 'react-i18next';
import { BsChevronRight } from 'react-icons/bs';
import { createUseStyles } from 'react-jss';
import { useShake } from '../../hooks/use-shake';
import { useStorage } from '../../hooks/use-storage';
import { useSwal } from '../../hooks/use-swal';
import { layoutDefaults } from '../../utils/layout-defaults';
import { publicResources } from '../../utils/public-resources';

function useEmptyAssignModal({ onAppDownloadClick }) {
  const storage = useStorage();
  const { swal } = useSwal({ storage });
  const instructionsRef = useRef();
  const classes = useStyles();
  const { t } = useTranslation();

  useShake({
    element: instructionsRef?.current,
  });

  async function load() {
    // const x = xRef.current;
  }

  async function fire() {
    await swal.fire({
      html: (
        <>
          {/* <div className={classes.title}>
            Faça isso no app <b>Menur</b>
          </div> */}
          <img
            className={classes.image}
            src={publicResources.image.emptyAssign}
            alt=""
          />
          <div ref={instructionsRef} className={classes.steps}>
            Ajustes <BsChevronRight /> QR Codes <BsChevronRight /> Cadastrar
            lote
          </div>
          <div className={classes.descriptionContainer}>
            <span>
              <span className={classes.description}>
                Siga as pasos acima no <b>app Menur</b>. Se você não tem o app,{' '}
              </span>
              <Button
                variant="link"
                onClick={() => onAppDownloadClick()}
                className={classes.link}
              >
                baixe agora
              </Button>
            </span>
          </div>
        </>
      ),
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: true,
      cancelButtonText: t('close'),
    });
  }

  return [load, fire];
}

const useStyles = createUseStyles({
  image: {
    borderRadius: layoutDefaults.radius,
    width: '100%',
    // border: '1px solid white',
  },
  title: {
    fontSize: layoutDefaults.biggestFontSize - 4,
    fontWeight: 'bold',
    textAlign: 'start',
    marginTop: layoutDefaults.verticalMargin,
    marginBottom: layoutDefaults.bigVerticalMargin,
    // border: '1px solid red',
  },
  steps: {
    fontSize: layoutDefaults.fontSize,
    opacity: layoutDefaults.opacity + 0.2,
    paddingTop: layoutDefaults.smallVerticalMargin,
    paddingBottom: layoutDefaults.smallVerticalMargin,
    marginTop: layoutDefaults.smallVerticalMargin,
    marginBottom: layoutDefaults.bigVerticalMargin,
    borderRadius: layoutDefaults.radius,
    backgroundColor: layoutDefaults.buttonBorder,
    // border: '1px solid red',
  },
  descriptionContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    textAlign: 'start',
    marginBottom: layoutDefaults.verticalMargin,
  },
  description: {
    fontSize: layoutDefaults.bigFontSize,
    opacity: layoutDefaults.opacity + 0.2,
    // border: '1px solid red',
  },
  link: {
    cursor: 'pointer',
    // fontSize: layoutDefaults.fontSize,
    color: layoutDefaults.linkColor,
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
    paddingBottom: 0,
    // border: "1px solid red",
  },
});

export { useEmptyAssignModal };
